(self["webpackChunk_dhl_account_app"] = self["webpackChunk_dhl_account_app"] || []).push([[983],{

/***/ 27983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__.p + "i18n/de-EU.d7cb1.json";

/***/ })

}])